import { EntityBase } from "./entity-base.model";
export class FiscalYear extends EntityBase {
  public Year: number;
  public StartDate: Date;
  public EndDate: Date;
}
